<template>
  <div class="scroll_nav_wrap">
    <div class="headNav">
      <div class="head">
        <div class="mainContent">
          <img
            @click="getActive('Inicio')"
            class="logo"
            src="@/assets/imgs/pla_logo_scroll.png"
            alt=""
          />
          <ul class="nav">
            <li :class="activeNav == 'Inicio' ? 'active' : ''">
              <a @click="getActive('Inicio')">Inicio</a>
            </li>
            <li :class="activeNav == 'Aviso' ? 'active' : ''">
              <a @click="getActive('Aviso')">Introducción</a>
            </li>
            <li :class="activeNav == 'sobre' ? 'active' : ''">
              <a @click="getActive('sobre')">Sobre nosotros</a>
            </li>
            <li>
              <a @click="openOptIn">OPT-IN</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./scss/nav.scss";

export default {
  name: "headNav",
  props: ["activeNav"],
  data() {
    return {
      // active: "Inicio",
    };
  },
  created() {
    // this.active = this.activeNav;
    // console.log(nav, this.active);
    // if (nav) {
    //   this.active = nav;
    // } else {
    //   localStorage.setItem('activeNav', "Inicio");
    // }
  },
  methods: {
    getActive(val) {
      // this.activeNav = val;
      let url = "";
      switch (val) {
        case "Inicio":
          url = "/home";
          break;
        case "sobre":
          url = "/about";
          break;
        case "Aviso":
          url = "/notice";
          break;
        case "loan":
          url = "/loan";
          break;
        case "ayuda":
          url = "/help";
          break;
      }
      this.$router.push(url);
    },
    openOptIn() {
      this.$store.commit('openSmsPopup');
    },
  },
};
</script>

<style>
</style>
